<template>
	<div class="title">
		<!-- <h1>{{ title }}</h1> -->
	</div>
</template>
<script>
export default {
	props: {
		title: {
			type: String,
			required: true,
			default: "タイトル",
		},
	},
}
</script>

<style lang="scss" scoped>
.title {
	width: 100%;
	padding: .75rem;
	font-size: 24px;
	font-weight: bold;
	background-color:#fefefe;
	// height:64px;
}
</style>
